import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

export interface Data {
  setting?: string;
}

export interface Variables {
  name: string;
}

export const QUERY = gql`
  query getSystemSettingValueByName($name: ID!) {
    setting: getSystemSettingValueByName(name: $name)
  }
`;

export const useSystemSettingValueQuery = (
  data?: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> => useQuery<Data, Variables>(QUERY, data);
